import InputValidate from './input-validate.vue'

export default InputValidate
